"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationAccountsReceivable_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var LocationAccountsReceivable_Factory = /** @class */ (function () {
    function LocationAccountsReceivable_Factory() {
    }
    LocationAccountsReceivable_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            BalanceAged30: model.BalanceAged30,
            BalanceAged60: model.BalanceAged60,
            BalanceAged90: model.BalanceAged90,
            BalanceCurrent: model.BalanceCurrent,
            BalanceTotal: model.BalanceTotal,
            CurrentDue: model.CurrentDue,
            InsuranceContractTotal: model.InsuranceContractTotal,
            InsuranceDue: model.InsuranceDue,
            InsuranceTotal: model.InsuranceTotal,
            InsuranceWriteOffTotal: model.InsuranceWriteOffTotal,
            LastDebitDate: Date_Factory_1.Date_Factory.CreateIncoming(model.LastDebitDate, { ignoreTimePortion: true }),
            LastPaymentAmount: model.LastPaymentAmount,
            LastPaymentDate: Date_Factory_1.Date_Factory.CreateIncoming(model.LastPaymentDate, { ignoreTimePortion: true }),
            LocationId: model.LocationId,
            PatientDue: model.PatientDue,
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    LocationAccountsReceivable_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            BalanceAged30: model.BalanceAged30,
            BalanceAged60: model.BalanceAged60,
            BalanceAged90: model.BalanceAged90,
            BalanceCurrent: model.BalanceCurrent,
            BalanceTotal: model.BalanceTotal,
            CurrentDue: model.CurrentDue,
            InsuranceContractTotal: model.InsuranceContractTotal,
            InsuranceDue: model.InsuranceDue,
            InsuranceTotal: model.InsuranceTotal,
            InsuranceWriteOffTotal: model.InsuranceWriteOffTotal,
            LastDebitDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.LastDebitDate, { ignoreTimePortion: true }),
            LastPaymentAmount: model.LastPaymentAmount,
            LastPaymentDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.LastPaymentDate, { ignoreTimePortion: true }),
            LocationId: model.LocationId,
            PatientDue: model.PatientDue,
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return LocationAccountsReceivable_Factory;
}());
exports.LocationAccountsReceivable_Factory = LocationAccountsReceivable_Factory;
